<template>
  <div>
    <header class="ma-3 pa-2 d-flex justify-space-between">
      <span class="text-h6 pl-1">{{ appName }}</span>
      <FlatButton @click="drawer = !drawer" icon="mdi-menu"></FlatButton>
    </header>
    <v-navigation-drawer v-model="drawer" absolute temporary>
      <div class="mt-1 text-center">
        <small class="text-caption">{{ version }}</small>
      </div>
      <v-list nav>
        <v-list-item-group>
          <template v-for="(nav, index) in navs">
            <v-list-item :key="index" @click="navigate(nav.path)">
              <v-list-item-icon>
                <v-icon>{{ nav.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ nav.label }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
import FlatButton from "@/components/FlatButton";

export default {
  components: {
    FlatButton,
  },
  data() {
    return {
      appName: process.env.VUE_APP_NAME,
      version: process.env.VUE_APP_VERSION,
      drawer: false,
      navs: [
        { icon: "mdi-apps", label: "Home", path: "" },
        { icon: "mdi-equalizer", label: "Analysis", path: "analysis" },
        { icon: "mdi-cog", label: "Setting", path: "setting" },
        { icon: "mdi-help-circle-outline", label: "Guide", path: "guide" },
        { icon: "", label: "Privacy", path: "privacy" },
      ],
    };
  },
  methods: {
    navigate(path) {
      if (this.$route.path === "/" + path) {
        return;
      }
      this.$router.push("/" + path);
    },
  },
};
</script>

<style scoped>
header {
  background: #efefef;
  box-shadow: -6px -6px 14px rgba(255, 255, 255, 0.7),
    -6px -6px 10px rgba(255, 255, 255, 0.5),
    6px 6px 8px rgba(255, 255, 255, 0.075), 6px 6px 10px rgba(0, 0, 0, 0.15);
}
</style>